var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 13.875L24.0001 6.9375L12.0001 0L8.18968e-05 6.9375L12.0001 13.875Z",
    fill: "#828AE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18968e-05 21.75V8.25001L11.4375 14.8623L11.4375 28.3623L8.18968e-05 21.75ZM12.4375 28.4346L24.0001 21.75V8.25001L12.4375 14.9346L12.4375 28.4346Z",
    fill: "#828AE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnStorage);
export default __webpack_public_path__ + "static/media/icn-storage.fbf768bdc0e6e50e43d37e3f42dcdef6.svg";
export { ForwardRef as ReactComponent };